'use strict';

import angular from 'angular';

import directive from './directive';

const MODULE_NAME = 'daupler.incidents.components.serviceEventMap';

var app = angular.module(MODULE_NAME, [
]);
app.directive('serviceEventMap', directive);

export default MODULE_NAME;
